"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _videoProgress = _interopRequireDefault(require("./video-progress/video-progress"));

var _playpause = _interopRequireDefault(require("./playpause/playpause"));

var _volume = _interopRequireDefault(require("./volume/volume"));

var _durationCurrent = _interopRequireDefault(require("./duration/duration-current"));

var _durationTotal = _interopRequireDefault(require("./duration/duration-total"));

var _share = _interopRequireDefault(require("./share/share"));

var _fullscreen = _interopRequireDefault(require("./fullscreen/fullscreen"));

var _controlsExtension = _interopRequireDefault(require("./controls-extension/controls-extension"));

var _contextMenuBlocker = _interopRequireDefault(require("../../context-menu-blocker/context-menu-blocker"));

var _controlsCloak = _interopRequireDefault(require("./cloaks/controls-cloak"));

var _videoLoader = _interopRequireDefault(require("./video-loader/video-loader"));

var _ratio = require("../../services/ratio/ratio.service");

var _indicatorCloak = _interopRequireDefault(require("./cloaks/indicator-cloak/indicator-cloak"));

var _quickSeek = _interopRequireDefault(require("./quick-seek/quick-seek"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Renders controls sets above a <VideoPlayer>
 * @param {object} props - See propTypes
 */
const VideoControls = props => {
  const {
    videoTag,
    container,
    ratio,
    isDesktopDevice,
    hasShare,
    hasPlay,
    hasProgress,
    hasVolume,
    hasFullscreen
  } = props;
  const set = props.set || (global.innerWidth >= 1024 ? 'desktop' : 'mobile');
  const {
    children
  } = props,
        otherProps = (0, _objectWithoutProperties2.default)(props, ["children"]);
  const ChildrenWithProps = children ? _react.default.Children.map(children, child => {
    if (!child) {
      return null;
    }

    return /*#__PURE__*/_react.default.cloneElement(child, _objectSpread(_objectSpread({}, children.props), otherProps));
  }) : null;

  if (!videoTag) {
    return null;
  }

  const [indicatorAction, setIndicatorAction] = (0, _react.useState)();
  const [lastInteraction, setLastInteraction] = (0, _react.useState)();

  const allProps = _objectSpread(_objectSpread({}, props), {}, {
    onInteraction: () => {
      setLastInteraction(new Date());
    }
  });

  const renderSets = {
    mobile: () => /*#__PURE__*/_react.default.createElement(_controlsCloak.default, (0, _extends2.default)({}, allProps, {
      lastInteraction: lastInteraction
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-controls video-controls--mobile-set"
    }, ChildrenWithProps, /*#__PURE__*/_react.default.createElement(_quickSeek.default, allProps), hasPlay && /*#__PURE__*/_react.default.createElement("span", {
      className: "video-controls__playpause"
    }, /*#__PURE__*/_react.default.createElement(_playpause.default, (0, _extends2.default)({
      toggleOnVideoClick: true
    }, allProps))), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-controls__bottom"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-controls__inner"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "video-controls__duration"
    }, /*#__PURE__*/_react.default.createElement(_durationCurrent.default, allProps), /*#__PURE__*/_react.default.createElement(_durationTotal.default, allProps)), hasShare && /*#__PURE__*/_react.default.createElement("span", {
      className: "video-controls__share"
    }, /*#__PURE__*/_react.default.createElement(_share.default, allProps)), hasFullscreen && /*#__PURE__*/_react.default.createElement("span", {
      className: "video-controls__fullscreen"
    }, /*#__PURE__*/_react.default.createElement(_fullscreen.default, allProps)), hasProgress && /*#__PURE__*/_react.default.createElement("span", {
      className: "video-controls__progress"
    }, /*#__PURE__*/_react.default.createElement(_videoProgress.default, allProps)), /*#__PURE__*/_react.default.createElement(_contextMenuBlocker.default, {
      element: container
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-controls__loader"
    }, /*#__PURE__*/_react.default.createElement(_videoLoader.default, props)))),
    desktop: () => {
      const isNarrow = ratio === _ratio.RATIOS_BY_NAME.vertical.key;
      return /*#__PURE__*/_react.default.createElement(_controlsCloak.default, (0, _extends2.default)({}, allProps, {
        lastInteraction: lastInteraction
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "video-controls video-controls--desktop-set"
      }, ChildrenWithProps, /*#__PURE__*/_react.default.createElement(_indicatorCloak.default, {
        action: indicatorAction,
        onShortcutChange: setIndicatorAction
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "video-controls__bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('video-controls__inner', {
          'video-controls__inner--narrow': isNarrow
        })
      }, hasProgress && /*#__PURE__*/_react.default.createElement("span", {
        className: "video-controls__progress"
      }, /*#__PURE__*/_react.default.createElement(_videoProgress.default, (0, _extends2.default)({}, allProps, {
        onShortcutChange: setIndicatorAction
      }))), hasPlay && /*#__PURE__*/_react.default.createElement("span", {
        className: "video-controls__playpause"
      }, /*#__PURE__*/_react.default.createElement(_playpause.default, (0, _extends2.default)({
        hasToolTip: true,
        toggleOnVideoClick: true
      }, allProps, {
        onShortcutChange: setIndicatorAction
      }))), hasVolume && isDesktopDevice && /*#__PURE__*/_react.default.createElement("span", {
        className: "video-controls__volume"
      }, /*#__PURE__*/_react.default.createElement(_volume.default, (0, _extends2.default)({
        hasToolTip: true,
        showSlider: !isNarrow
      }, allProps, {
        onShortcutChange: setIndicatorAction
      }))), /*#__PURE__*/_react.default.createElement("span", {
        className: "video-controls__duration"
      }, /*#__PURE__*/_react.default.createElement(_durationCurrent.default, allProps), /*#__PURE__*/_react.default.createElement(_durationTotal.default, allProps)), ratio === _ratio.RATIOS_BY_NAME.vertical.key ? /*#__PURE__*/_react.default.createElement(_controlsExtension.default, allProps) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "video-controls__extension"
      }, hasShare && /*#__PURE__*/_react.default.createElement("span", {
        className: "video-controls__share"
      }, /*#__PURE__*/_react.default.createElement(_share.default, (0, _extends2.default)({
        hasToolTip: true
      }, allProps))), hasFullscreen && /*#__PURE__*/_react.default.createElement("span", {
        className: "video-controls__fullscreen"
      }, /*#__PURE__*/_react.default.createElement(_fullscreen.default, (0, _extends2.default)({
        hasToolTip: true
      }, allProps))))), /*#__PURE__*/_react.default.createElement(_contextMenuBlocker.default, {
        element: container
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "video-controls__loader"
      }, /*#__PURE__*/_react.default.createElement(_videoLoader.default, props))));
    }
  };
  return renderSets[set] ? renderSets[set]() : null;
};
/* eslint-disable react/no-unused-prop-types */


VideoControls.propTypes = {
  videoTag: _propTypes.default.instanceOf(global.Element),
  container: _propTypes.default.instanceOf(global.Element),
  videoUrl: _propTypes.default.string,
  duration: _propTypes.default.number,
  // TODO: make this required again when this is fixed: https://github.com/facebook/react/issues/6653
  ratio: _propTypes.default.oneOf(_ratio.RATIO_KEYS),
  resolution: _propTypes.default.number,
  callbacks: _propTypes.default.shape({
    onInit: _propTypes.default.func,
    onVolumeChange: _propTypes.default.func,
    onFullscreen: _propTypes.default.func,
    onFullscreenExit: _propTypes.default.func,
    onShare: _propTypes.default.func,
    setIndicatorAction: _propTypes.default.func,
    onPlaypause: _propTypes.default.func,
    onEnded: _propTypes.default.func,
    onHalfWay: _propTypes.default.func,
    onQuarter: _propTypes.default.func,
    onTreeQuarters: _propTypes.default.func,
    onTenSec: _propTypes.default.func
  }),
  set: _propTypes.default.oneOf(['desktop', 'mobile']),
  isDesktopDevice: _propTypes.default.bool,
  onShortcutChange: _propTypes.default.func,
  hasShare: _propTypes.default.bool
};
/* eslint-enable react/forbid-prop-types */

VideoControls.defaultProps = {
  videoTag: null,
  container: null,
  videoUrl: undefined,
  callbacks: {},
  duration: undefined,
  ratio: _ratio.RATIOS_BY_NAME.wide.key,
  resolution: _ratio.RATIOS_BY_NAME.wide.height,
  set: undefined,
  isDesktopDevice: true,
  onShortcutChange: () => {},
  hasShare: true,
  hasPlay: true,
  hasProgress: true,
  hasVolume: true,
  hasFullscreen: true
};
var _default = VideoControls;
exports.default = _default;